import React from 'react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { BsArrowUpRight } from "react-icons/bs";
import ContactNowPopup from './ContactNowPopup';
// import ContactNowPopup from './ContactNowPopup';


function About() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <section className='about-sec'>
            <div className='container'>
                <div className='row mb-5' id='about-end-bottom'>
                    <div className='col-xlg-12 col-lg-12 mb-5'>
                        <div className='about-section'>
                            <h2>About</h2>
                            <h3>Dr.Mahadevan</h3>
                            <p className='section-para'><b>I am Dr. Mahadevan G.R, a Senior Physician, Diabetologist,</b> and Consultant in Critical Care & Geriatric Medicine. With over 15 years of experience, my work is driven by a passion for improving patient outcomes through both evidence-based practices and compassionate care. I specialize in managing complex medical conditions, particularly in critical care settings, and have a strong focus on geriatric health and diabetes management.</p>
                            <p className='section-para mb-5'>In addition to my clinical work, I have led several high-stakes initiatives, such as heading the COVID clinical team at MIOT Hospitals, where I oversaw a large COVID unit and cared for critically ill patients on ECMO support. My approach is centered around a multidisciplinary care model, combining advanced medical techniques with a holistic approach to patient well-being.</p>
                        </div>
                        <div className='affiliations'>
                            <h3>Affiliations</h3>
                            <p>Tamil Nadu Medical Council -78437</p>
                            <p>Life member of Indian Society of Critical Care Medicine</p>
                            <p>Member of European Society of Critical Care Medicine</p>
                            <p>Members of Common Health Medical Association(CMA)</p>
                        </div>
                        <Button className='about-contact-btn' variant="primary" onClick={handleShow} style={{ background: '#0eb5cd', color: '#fffff', border: 'none' }}>Contact Now</Button>

                        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
                            <Modal.Body>
                                <section className="py-5 bodyofcontactform">
                                    <Container>
                                        <Row>
                                            <Col className='conact-form-heading' md={12}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h2 className='contact-now-form-title' >Let's talk</h2>
                                                    <Button
                                                        onClick={handleClose}
                                                        className="close-button"
                                                        variant="link"
                                                        style={{
                                                            fontSize: '40px',
                                                            color: '#000',
                                                            textDecoration: 'none',
                                                            padding: '0 8px',
                                                            position: 'relative',
                                                            right: '0%',
                                                            bottom: '60px'
                                                        }}
                                                    >
                                                        ×
                                                    </Button>
                                                </div>
                                                <p className='about-conact-details' style={{ fontWeight: '600', fontSize: '18px' }}>
                                                    Contact Number: <a href="tel:+919940451580">+91 9940451580</a><br />
                                                    Email: <a href="mailto:drgrmaha@gmail.com">drgrmaha@gmail.com</a>
                                                </p>
                                            </Col>
                                        </Row>

                                        <ContactNowPopup />
                                    </Container>
                                </section>
                            </Modal.Body>
                        </Modal>

                    </div>
                </div>
            </div>
            <div className='container' id='dr-mahadevan-logo'>
                <div className='row'>
                    <div className='col-xlg-4 col-lg-4 mb-4'>
                        <div>
                            <img src="assets/images/maya-nursing-home-logo.png" alt="Dr. Mahadevan Logo" />
                        </div>
                    </div>
                    <div className='col-xlg-8 col-lg-8 mb-4'>
                        <div className='section-para'>
                            <p><strong>Maya Nursing Home Pvt Ltd</strong> has been a trusted healthcare provider in Ashok Nagar for over 40 years. We offer quality secondary and tertiary care, specializing in General Medicine, Geriatric Care, ICU Care and General Surgery. </p>
                                
                                {/* Surgery, Obstetrics, Gynaecology, and Pediatrics — all at an affordable cost.</p> */}
                        </div>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-xlg-4 col-lg-4 mb-4'>
                        <div>
                            <img src="assets/images/doctor-at-home-logo.png" alt="Dr. Mahadevan Logo" />
                        </div>
                    </div>
                    <div className='col-xlg-8 col-lg-8 mb-4'>
                        <div className='section-para'>
                            <p><strong>Doctor at Home</strong> brings compassionate, care directly to your doorstep—offering doctor consultations, wound care, physiotherapy, and diagnostic support for elderly or bedridden patients in the comfort of home.</p>
                        </div>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-xlg-4 col-lg-4 mb-4'>
                        <div>
                            <img src="assets/images/maya-palative-care-logo.png" alt="Dr. Mahadevan Logo" />
                        </div>
                    </div>
                    <div className='col-xlg-8 col-lg-8'>
                        <div className='section-para'>
                            <p><strong>Maya Palliative Care</strong> Unit Chennai offers compassionate, care for patients facing serious or life-limiting illnesses.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
}

export default About;
